<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="searchCriterias"></ng-container>
        </tt-card>

        <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="stockhistory_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="searchCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <ng-container *ngTemplateOutlet="list"></ng-container>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #searchCriterias>
    <ng-container *ngIf="!!setting">
        <tt-date-range ttRememberId="w_stockhistory" ttLabel="date_fom_tom" ttLabelView="top" [(ttStartDate)]="setting.date_fom" [(ttEndDate)]="setting.date_tom" [(ttInterval)]="setting.dateselector_index" (ttModelChange)="updateHistories()"></tt-date-range>
        <tt-input ttLabel="filtervalue" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>

<ng-template #list>
    <ng-container *ngIf="!!setting">
        <tt-list-legacy [listItems]="itemsListHistories" ltype="multi" [designVar]="'s12t0'" typevar="g" [filterVal]="setting.filtervalue"></tt-list-legacy>

        <tt-card *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </ng-container>
</ng-template>
